import { render, staticRenderFns } from "./HotspotDetail.vue?vue&type=template&id=61bcadac&scoped=true"
import script from "./HotspotDetail.vue?vue&type=script&lang=js"
export * from "./HotspotDetail.vue?vue&type=script&lang=js"
import style0 from "./HotspotDetail.vue?vue&type=style&index=0&id=61bcadac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bcadac",
  null
  
)

export default component.exports